module.exports = __webpack_public_path__ + "img/bone.64069432.png";